import api from "@/api";

export const cartaoService = {
  // ── Lista ──
  async getLight(params = {}) {
    const { data } = await api.get("/cartoes/light", { params });
    return data;
  },

  async getLightAll() {
    const { data } = await api.get("/cartoes/light/all");
    return data;
  },

  async getLightFiltrado(filtros, page = 1, perPage = 50) {
    const { data } = await api.post("/cartoes/light/filtrar", {
      filtros,
      page,
      perPage,
    });
    return data;
  },

  async contarComFiltros(filtros) {
    const { data } = await api.post("/cartoes/light/contar", { filtros });
    return data;
  },

  // ── Perfil ──
  async getPerfil(qrCode, restauranteId = null) {
    const { data } = await api.get(`/cartoes/perfil/${qrCode}`, {
      params: restauranteId ? { restaurante_id: restauranteId } : {},
    });
    return data;
  },

  // ── Desconto ──
  async updateDesconto(qrCode, restauranteId, desconto) {
    const { data } = await api.put("/cartoes/desconto", {
      qr_code: qrCode,
      restaurante_id: restauranteId,
      desconto,
    });
    return data;
  },

  // ── NIF ──
  async updateNif(qrCode, nif) {
    const { data } = await api.put("/cartoes/nif", { qr_code: qrCode, nif });
    return data;
  },

  // ── Insights ──
  async getInsights(payload) {
    const { data } = await api.post("/cartoes/light/insights", payload);
    return data;
  },

  // ── Matriz descontos ──
  async getMatrizDescontos(params = {}) {
    const { data } = await api.get("/cartoes/descontos/matriz", { params });
    return data;
  },

  // ── Bulk ──
  async iniciarBulk(desconto, qrCodes, restauranteIds) {
    const { data } = await api.post("/bulk/iniciar", {
      desconto,
      qrCodes,
      restauranteIds,
    });
    return data;
  },

  async getBulkStatus(bulkId) {
    const { data } = await api.get(`/bulk/detalhes/${bulkId}/temp`);
    return data;
  },

  async listarBulks() {
    const { data } = await api.get("/bulk/listar");
    return data;
  },

  async getBulkErros(bulkId) {
    const { data } = await api.get(`/bulk/detalhes/${bulkId}`);
    return data;
  },

  // ── ZoneSoft Sync ──
  async getSyncJobs() {
    const { data } = await api.get("/cartoes/sync/jobs");
    return data;
  },

  async getSyncJobDetails(jobId) {
    const { data } = await api.get(`/cartoes/sync/jobs/${jobId}`);
    return data;
  },

  async iniciarSync(payload) {
    const { data } = await api.post("/cartoes/sync/cartoes", payload);
    return data;
  },
};
